import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import template from './company.vue';
import apiService from '@/services/api.service';
import { Action } from '@/store';
import { Tab } from '..';

@Component({
  mixins: [template],
})
export default class SettingsCompany extends Vue {
  @Prop() model!: { name: string };
  @Prop() tab!: Tab;
  name: string = '';

  @Watch("name")
  modelChange() {
    this.$emit("applyChange", this.tab, { name: this.name });
  }

  mounted() {
    this.name = this.model.name;
  }

  async saveChanges() {
    try {
      await apiService.saveCompany({ name: this.name });
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_success', type: 'success' });
      this.$emit("changesSaved", this.tab);
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_error', type: 'danger' });
    }
  }
}